module.exports = "/_next/static/images/99cf9e20507c054efad4a242c11b4387-man-looking-up-smiling-xs@3x.jpg.webp";